import React from 'react';

import { CheckboxAdvanced } from 'reactApp/components/CheckboxAdvanced/CheckboxAdvanced';

import { BasicField } from './_BasicField';

export const FieldCheckbox = ({
    name = undefined,
    type = undefined,
    onChange = undefined,
    label = ' ', // important for style of field
    ...otherInputProps
}) => (
    <BasicField
        {...{
            name,
            type,
            onChange,
            label,
            control: CheckboxAdvanced,
            ...otherInputProps,
        }}
    />
);
